import { createContext, useContext, useState, useEffect, useCallback } from "react";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getQuerySchema, updateQuerySchema } from "../../api/query";

const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const toaster = useToaster();
  const [initialValues, setInitialValues] = useState({ paths: [] });
  const [loading, setLoading] = useState(true);

  const fetchSchema = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getQuerySchema();
      const data = res.data;
      if (data && data.paths) {
        setInitialValues({
          ...data,
          contact_fields: data.contact_fields || []
        });
      }
    } catch (error) {
      toaster.error("Error", "Failed to fetch schema");
    } finally {
      setLoading(false);
    }
  }, [toaster]);

  useEffect(() => {
    fetchSchema();
  }, [fetchSchema]);

  const handleSubmit = async (values) => {
    const finalValues = {
      ...values,
      paths: values.paths.map((path, pIndex) => ({
        ...path,
        id: path.id || `path_${pIndex}`,
        steps: path.steps ? path.steps.map((s, sIndex) => ({
          ...s,
          id: s.id || `step_${sIndex}`,
          questions: s.questions ? s.questions.map((q, qIndex) => ({
            ...q,
            id: q.id || q.title.toLowerCase().replace(/[^a-z0-9]/g, '_').substring(0, 20) || `q_${qIndex}`
          })) : []
        })) : []
      }))
    };

    try {
      await updateQuerySchema(finalValues);
      toaster.success(Const.MESSAGES.SUCCESS, "Query form data saved successfully!");
    } catch (error) {
      toaster.error("Error", "Failed to save query form data.");
    }
  };

  if (loading) {
    return <div className="p-8 text-center">Loading...</div>;
  }

  return (
    <PageContext.Provider value={{ handleSubmit, initialValues }}>
      {children}
    </PageContext.Provider>
  );
};

export const useQueryFormProvider = () => {
  return useContext(PageContext);
};
